
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staking/lido/wrap",
      function () {
        return require("private-next-pages/staking/lido/wrap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staking/lido/wrap"])
      });
    }
  